// A passphrase, not a PIN: a phrase can be as long as the person wants, where six digit boxes would
// announce their own length and cap the entropy at a million. A plain password input, so a password
// manager can fill it, with a way to see it for a long phrase typed on a phone. Autocorrect and
// spellcheck stay off, since a spellchecker posts what it checks.
import PropTypes from 'prop-types'
import {useId, useState} from 'react'

import HideIcon from '@mui/icons-material/VisibilityOffOutlined'
import IconButton from '@mui/material/IconButton'
import ShowIcon from '@mui/icons-material/VisibilityOutlined'

const PassphraseField = ({label, value, onChange, autoComplete, autoFocus = false, hint = null}) => {
  const [revealed, setRevealed] = useState(false)
  const id = useId()

  // The toggle sits beside the input rather than inside its label, which would name it too.
  return (
    <div className='dialog-field'>
      <label className='field-label' htmlFor={id}>{label}</label>
      <span className='passphrase-wrap'>
        <input
          id={id}
          type={revealed ? 'text' : 'password'}
          value={value}
          onChange={event => onChange(event.target.value)}
          autoComplete={autoComplete}
          autoCorrect='off'
          autoCapitalize='off'
          spellCheck={false}
          autoFocus={autoFocus}
        />
        <IconButton
          className='passphrase-reveal'
          size='small'
          aria-label={revealed ? `Hide ${label.toLowerCase()}` : `Show ${label.toLowerCase()}`}
          onClick={() => setRevealed(shown => !shown)}>
          {revealed ? <HideIcon fontSize='small' /> : <ShowIcon fontSize='small' />}
        </IconButton>
      </span>
      {hint && <span className='field-hint'>{hint}</span>}
    </div>
  )
}

PassphraseField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  // "current-password" for one being typed in, "new-password" for one being chosen.
  autoComplete: PropTypes.oneOf(['current-password', 'new-password']).isRequired,
  autoFocus: PropTypes.bool,
  hint: PropTypes.string
}

export default PassphraseField
